import { createSelector } from 'reselect';
import type { RootState } from '../../configuration/setup/store';

export const selectRoute = (state: RootState) => state.route;
export const selectRouteDeparture = createSelector(selectRoute, state => state.departure);
export const selectRouteConstraints = createSelector(selectRoute, state => state.constraints);
export const selectVehicleCosts = createSelector(selectRoute, state => state.vehicleCosts);
export const selectEnergyCosts = createSelector(selectRoute, state => state.energyCosts);
